import {
  Actions,
  Box,
  ButtonLink,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';

import { URL_ACCOUNT_TEAM } from '@seek/adv-constants';

import AddUsersIcon from '../../icons/AddUsersIcon';
import { trackEvent } from 'src/modules/events';
import { EVENT_NAME_MANAGE_NOTIFICATIONS_ADD_TEAMMATES_PRESSED } from 'src/constants/pageTrackingData';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';
export const AddTeamMemberView = () => {
  const { t } = useTranslations(translations);
  const handleOnClick = () => {
    trackEvent(EVENT_NAME_MANAGE_NOTIFICATIONS_ADD_TEAMMATES_PRESSED, {});
  };

  return (
    <Box display="flex" justifyContent="center" marginY="xlarge">
      <Box textAlign="center" maxWidth="small">
        <Stack space="large">
          <Box>
            <AddUsersIcon />
          </Box>
          <Heading level="4">{t('No team members added yet')}</Heading>
          <Text tone="secondary">
            {t('To add team members to this job...')}
          </Text>
          <Box display="flex" justifyContent="center">
            <Actions>
              <ButtonLink
                href={URL_ACCOUNT_TEAM}
                target="_blank"
                rel="noopener"
                onClick={handleOnClick}
                data-testid="add-team-member-button"
              >
                {t('Add team members to account')}
              </ButtonLink>
            </Actions>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
